<script setup lang="ts">
import { computed } from "vue";

import { TSiteAddress } from "@/data/api/kili/sites/types/sites.type";
import { formatCompleteGeolocatedAddress, formatCompletePostalAddress, hasPostalAddress } from "@/utils/address-utils";

interface IProps {
  address: TSiteAddress;
  showMarkerIcon?: boolean;
}

const props = defineProps<IProps>();

const formattedSiteAddress = computed<string>(() => {
  return hasPostalAddress(props.address)
    ? formatCompletePostalAddress(props.address.postalSiteAddress)
    : formatCompleteGeolocatedAddress(props.address.geolocatedSiteAddress);
});
</script>

<template>
  <div class="flex flex-row items-left justify-start gap-2">
    <i
      v-if="props.showMarkerIcon"
      class="pi pi-map-marker text-text-secondary text-sm"
    />

    <address
      class="text-text-secondary truncate text-ellipsis overflow-hidden not-italic"
      :title="formattedSiteAddress"
    >
      {{ formattedSiteAddress }}
    </address>
  </div>
</template>
